export class PaymentInfo {
  // card number
  public number = '';

  // card expiration date
  public month = '';

  // card expiration year
  public year = '';

  // card verificatgion value
  public cvv = '';

  // bank (ach or eft) routing
  public routing = '';

  // bank (ach or eft) account number
  public account = '';

  // stored/resolved Payment Method ID
  public method = '';

  // retain-on-use intent
  public retain = false;

  // global application flag to control payment choice visibility
  public add = false;

  // spreedly token -- should be able to get rid of these
  public token = '';
  public tokenValidationError = '';

  // card type detected by tokenizer
  public cardType = '';
}
